// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { Batch } from './batch';
import { Counterparty } from './counterparty';
import { Employee } from './employee';
import { PracticeBank } from './practice-bank';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Bank extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  bankId!: number;
  code?: string;
  createdBy!: string;
  createdDate!: Date;
  description!: string;
  flags?: number;
  ibflags?: number;
  iburl?: string;
  locationId!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  accounts!: Account[];
  batches!: Batch[];
  counterparties!: Counterparty[];
  employees!: Employee[];
  practiceBanks!: PracticeBank[];
}

